module.exports={close:"Lukk",error:"Feil",info:"Informasjon",success:"Vellykket",warning:"Advarsel"};